/* eslint-disable no-unused-expressions */

import React from 'react'

import {
  CREATE_PROJECT_COLORS_STEP,
  CREATE_PROJECT_IMAGES_STEP
} from '../constant'
import ProjectOptions from './ProjectOptions'

const ProjectParking = ({ setStep = () => {}, type = 'create' }) => {
  const PARKING = 'parking'
  return (
    <div className='bg-menuGray min-h-screen relative mb-4'>
      <div className='p-6 bg-grey-8 rounded font-openSans'>
        <h1 className='font-black text-lg pt-3 font-openSans'>Parking</h1>
        <div className='border-b-2 border-black my-2'></div>
        <h2 className='font-openSans'>
          Fill below all the available parking options for this project
        </h2>
        <div className='mt-4 col-span-2'>
          <ProjectOptions viewMode={type} type={PARKING} setStep={setStep} prev={CREATE_PROJECT_IMAGES_STEP} next={CREATE_PROJECT_COLORS_STEP} />
        </div>
      </div>
    </div>
  )
}

export default ProjectParking
